class InfoDialogTrigger extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick(e) {
    e.preventDefault();
    e.stopPropagation();
    const label = this.dataset.infoTrigger;
    if (!label) return;

    const dialog = document.querySelector(`[data-info-dialog="${label}"]`);
    if (!dialog) return;

    dialog.classList.add('is-open');
    document.body.classList.add('configurator-dialog-open');
  }
}

if (!customElements.get('info-dialog-trigger')) {
  customElements.define('info-dialog-trigger', InfoDialogTrigger);
}

class InfoDialog extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick(e) {
    const closeBtn = e.target.closest('[data-info-dialog-close]');
    if (!closeBtn) return;

    e.preventDefault();
    this.classList.remove('is-open');
    document.body.classList.remove('configurator-dialog-open');
  }
}

if (!customElements.get('info-dialog')) {
  customElements.define('info-dialog', InfoDialog);
}
